let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fsbZm")).then(() => parcelRequire('52A0r'));